const { registerBlockType } = wp.blocks;
const { RichText, InspectorControls } = wp.blockEditor;
const { TextControl, PanelBody, SelectControl } = wp.components;
const { Fragment, useEffect, useState } = wp.element;
const { __ } = wp.i18n;

import { parseHubSpotShortcode } from '../utils/methods';
import { floatingFormSize } from '../../../resources/scripts/module/form';

registerBlockType('pg/floating-form', {
  title: 'PG Floating Form',
  icon: 'welcome-learn-more',
  category: 'layout',
  attributes: {
    formShortcode: { type: 'string', default: '' },
    formTitle: { type: 'string', default: '' },
    formClass: { type: 'string', default: 'floating-form' },
    sectionClass: { type: 'string', default: 'section-light-primary' },
  },
  edit: ({ attributes, setAttributes }) => {
    const { formShortcode, formTitle, formClass, sectionClass } = attributes;
    const [loaded, setLoaded] = useState(false);

    const onChangeSectionClass = (newClass) => {
      setAttributes({ sectionClass: newClass });
    };

    const loadHubSpotScript = () => {
      if (window.hbspt) {
        setLoaded(true);
        return;
      }
      const script = document.createElement('script');
      script.src = '//js.hsforms.net/forms/v2.js';
      script.onload = () => setLoaded(true);
      document.body.appendChild(script);
    };

    useEffect(() => {
      loadHubSpotScript();
    }, []);

    useEffect(() => {
      if (loaded && formShortcode) {
        const { portalId, formId } = parseHubSpotShortcode(formShortcode);
        if (portalId && formId) {
          const target = `.my-hubspot-form-${formId}`;
          window.hbspt.forms.create({
            portalId,
            formId,
            target,
            onFormReady: ($form) => {
              floatingFormSize();
            },
          });
        }
      }
    }, [loaded, formShortcode, floatingFormSize]);

    return (
      <Fragment>
        <InspectorControls>
          <PanelBody title={__('Form Settings')}>
            <TextControl
              label={__('HubSpot Form Shortcode')}
              value={formShortcode}
              onChange={(value) => setAttributes({ formShortcode: value })}
            />
            <SelectControl
              label={__('Section Class')}
              value={sectionClass}
              options={[
                { label: 'Dark Secondary', value: 'section-dark-secondary' },
                { label: 'Dark Primary', value: 'section-dark-primary' },
                { label: 'Light Primary', value: 'section-light-primary' },
                { label: 'Light Secondary', value: 'section-light-secondary' },
              ]}
              onChange={onChangeSectionClass}
            />
            <TextControl
              label={__('Form Class')}
              value={formClass}
              onChange={(value) => setAttributes({ formClass: value })}
            />
          </PanelBody>
        </InspectorControls>
        <section
          className={sectionClass}
          data-no-padding={1}
          data-on-floating={1}
        >
          <div className={`form-wrapper ${formClass}`.trim()}>
            <RichText
              tagName="h3"
              value={formTitle}
              onChange={(value) => setAttributes({ formTitle: value })}
              placeholder={__('Enter Form Title...')}
            />
            {parseHubSpotShortcode(formShortcode) && (
              <div
                className={`my-hubspot-form-${
                  parseHubSpotShortcode(formShortcode).formId || ''
                }`}
              ></div>
            )}
          </div>
        </section>
      </Fragment>
    );
  },
  save: ({ attributes }) => {
    const { formShortcode, formTitle, formClass, sectionClass } = attributes;

    return (
      <section
        className={sectionClass}
        data-no-padding={1}
        data-on-floating={1}
      >
        <div className={`form-wrapper ${formClass}`.trim()}>
          <RichText.Content tagName="h3" value={formTitle} />
          {parseHubSpotShortcode(formShortcode) && (
            <div
              className={`my-hubspot-form-${
                parseHubSpotShortcode(formShortcode).formId || ''
              }`}
            ></div>
          )}
        </div>
      </section>
    );
  },
});
